import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, ArrowRight, TrendingUp, Gift, AlertCircle } from 'lucide-react';

const NewsSection = () => {
  const newsItems = [
    {
      id: 1,
      slug: 'uk-gambling-regulations-2026',
      title: 'New UK Gambling Regulations Take Effect in 2026',
      excerpt: 'The latest regulatory updates bring stricter player protection measures and enhanced responsible gaming tools across all UK-licensed operators.',
      date: '01.12.2025',
      category: 'Regulations',
      icon: <AlertCircle className="w-6 h-6" />,
      color: 'from-brown-700 to-brown-900'
    },
    {
      id: 2,
      slug: 'top-slots-winter-2025',
      title: 'Top 5 Slots Dominating UK Casino Lobbies This Winter',
      excerpt: 'From seasonal themed games to high-volatility titles, discover which slots are capturing player attention and delivering the biggest wins.',
      date: '01.12.2025',
      category: 'Games',
      icon: <TrendingUp className="w-6 h-6" />,
      color: 'from-beige-400 to-brown-600'
    },
    {
      id: 3,
      slug: 'december-bonuses-2025',
      title: 'Exclusive December Bonuses: Up to £500 Extra Play',
      excerpt: 'Leading UK casinos are rolling out festive promotions with boosted welcome offers, free spin packages, and cashback deals perfect for holiday gaming.',
      date: '01.12.2025',
      category: 'Bonuses',
      icon: <Gift className="w-6 h-6" />,
      color: 'from-brown-600 to-beige-500'
    }
  ];

  return (
    <section id="news" className="py-20 px-4 bg-gradient-to-b from-brown-50 to-beige-100">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-brown-900 mb-4">
            Latest Casino News & Updates
          </h2>
          <p className="text-xl text-brown-700 max-w-2xl mx-auto">
            Stay informed about industry changes, new game releases, and exclusive bonus opportunities
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {newsItems.map((news, index) => (
            <Link
              key={news.id}
              to={`/news/${news.slug}`}
              data-discover="true"
              className="block glass-strong rounded-3xl overflow-hidden hover:scale-105 transition-transform duration-300 group"
            >
              {/* News Image */}
              <div className="relative h-48 overflow-hidden">
                <img 
                  src={`/images/${index === 0 ? 'alexander-schimmeck-QX0SWFpB2ho-unsplash.webp' : index === 1 ? 'amanda-jones-K2PAVcngNvY-unsplash.webp' : 'esteban-lopez-OfdFHy1zxjQ-unsplash.webp'}`}
                  alt={news.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-br from-beige-900/40 to-brown-900/40"></div>
                <div className={`absolute top-4 left-4 w-12 h-12 rounded-xl bg-gradient-to-br ${news.color} flex items-center justify-center text-white`}>
                  {news.icon}
                </div>
                <div className="absolute bottom-4 right-4 px-3 py-1 glass rounded-full text-xs font-semibold text-white">
                  {news.category}
                </div>
              </div>

              <div className="p-6">
                <div className="flex items-center space-x-2 text-sm text-brown-600 mb-3">
                  <Calendar className="w-4 h-4" />
                  <span>{news.date}</span>
                </div>
                <h3 className="text-xl font-bold text-brown-900 mb-3 group-hover:text-brown-700 transition-colors">
                  {news.title}
                </h3>
                <p className="text-brown-700 mb-4 leading-relaxed line-clamp-3">
                  {news.excerpt}
                </p>
                <div className="flex items-center space-x-2 text-brown-800 font-semibold group-hover:text-brown-900 transition-colors">
                  <span>Read More</span>
                  <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NewsSection;

